export const allowRegister = JSON.parse(process.env.REACT_APP_ALLOW_REGISTER) || false;
export const allow2Oauth = JSON.parse(process.env.REACT_APP_ALLOW_2OAUTH) || false;
export const allowActive = JSON.parse(process.env.REACT_APP_ALLOW_ACTIVE) || false;
export const appName = process.env.REACT_APP_NAME || "";
export const appDescription = process.env.REACT_APP_DESCRIPTION || "";
